import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Contact API
export const submitContactForm = async (formData) => {
  try {
    const response = await axios.post(`${API}/contact`, formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Blog API
export const getBlogPosts = async () => {
  try {
    const response = await axios.get(`${API}/blog`);
    return response.data.posts;
  } catch (error) {
    console.error('Error fetching blog posts:', error);
    return [];
  }
};

export const getBlogPost = async (postId) => {
  try {
    const response = await axios.get(`${API}/blog/${postId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching blog post:', error);
    return null;
  }
};

// Testimonials API
export const getTestimonials = async () => {
  try {
    const response = await axios.get(`${API}/testimonials`);
    return response.data.testimonials;
  } catch (error) {
    console.error('Error fetching testimonials:', error);
    return [];
  }
};

// Regions API
export const getRegions = async () => {
  try {
    const response = await axios.get(`${API}/regions`);
    return response.data.regions;
  } catch (error) {
    console.error('Error fetching regions:', error);
    return [];
  }
};
